import { render, staticRenderFns } from "./CentroDiagnosticoComponente.vue?vue&type=template&id=1b3045fe"
import script from "./CentroDiagnosticoComponente.vue?vue&type=script&lang=js"
export * from "./CentroDiagnosticoComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports